/* PRO prices shown in the terminal. Must match the landing's /pro page
   (Stripe prices there). The yearly plan is the default and comes first. */
// A szám és a pénznem / mértékegység között nem törő szóköz (U+00A0).
export const PRO_PRICE_TEXT = '399\u00a0€/év vagy 49\u00a0€/hó';
/* A próbavégi ablak PRO-gombja alatt (a Plusz a fő ajánlat). */
export const PRO_PRICE_SHORT = 'havi 49\u00a0€ vagy 399\u00a0€/év';

/* Plusz (SZINTMATRIX, „A kommunikáció iránya”): havi 12 €, vagy 99 €/év. */
export const PLUSZ_PRICE_TEXT = 'havi 12\u00a0€, vagy éves díjjal 8,25\u00a0€/hó';
/* Minden Plusz-gomb a landing /plusz oldalának árblokkjához visz (Plusz 3. kör).
   A #arak a munkamenet-átadásnál w3k_anchor-ként megy (utils/landing.js). */
export const PLUSZ_PATH = '/plusz#arak';
